export default "__VITE_ASSET__c7aaf10b__"